import store from 'store'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ADMIN_TOKEN_KEY } from 'spencer'

const isDev = process.env.NODE_ENV !== 'production'

const httpLink = createHttpLink({
  uri: process.env.VUE_APP_ADMIN_ENDPOINT
})

const authLink = setContext((_, { headers }) => {
  const token = store.get(ADMIN_TOKEN_KEY)
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const link = ApolloLink.from([authLink, httpLink])

const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  connectToDevTools: isDev
})

export default client
